var React = require('react');

function Flutter (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#d8d8d8","transform":"translate(-.001 -.001)"},[React.createElement("path",{"d":"m26.223 0-26.223 26.223 8.117 8.117 34.339-34.34z","key":0}),React.createElement("path",{"d":"m86.189 145.4-14.04 14.04 8.147 8.269 8.1-8.1 14.204-14.209z","transform":"translate(-60.149 -121.214)","key":1}),React.createElement("path",{"d":"m121.133 238.922 6.167 6.167h16.142l-14.208-14.269z","transform":"translate(-100.986 -192.43)","key":2}),React.createElement("path",{"d":"m71.6 189.679 8.117-8.117 8.223 8.193-8.1 8.1z","transform":"translate(-59.691 -151.365)","key":3}),React.createElement("path",{"d":"m121.133 242.357 6.746-2.239.67-5.178z","transform":"translate(-100.986 -195.866)","key":4})]));
}

Flutter.defaultProps = {"height":"52.659","viewBox":"0 0 42.456 52.659","width":"42.456"};

module.exports = Flutter;

Flutter.default = Flutter;
